import styled, {css} from 'styled-components'

export const StyledMailerTabs = styled.div(
    ({theme: {palette, spacing}}) => css`
        display: flex;
        gap: ${spacing * 4}px;
        padding: 0 ${spacing * 6}px;
        border-bottom: 1px solid ${palette.neutral[200]};
    `
)

export const StyledMailerTabButton = styled.button<{$active: boolean}>(
    ({theme: {palette, typography, spacing}, $active}) => css`
        ${typography.textMd};
        background: none;
        border: none;
        cursor: pointer;
        padding: ${spacing * 2}px ${spacing}px;
        margin-bottom: -1px;
        color: ${$active ? palette.primary[600] : palette.neutral[500]};
        border-bottom: 2px solid ${$active ? palette.primary[600] : 'transparent'};
        font-weight: ${$active ? 600 : 500};
        transition:
            color 0.15s ease,
            border-color 0.15s ease;

        &:hover {
            color: ${$active ? palette.primary[600] : palette.neutral[700]};
        }
    `
)
